<template>
  <v-dialog :value="show" width="100%">
    <v-card>
      <v-card-title class="primary">
        <span class="white--text text-uppercase">
          SUPPORTING DOCUMENT
        </span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-flex xs12 class="mt-5">
          <v-simple-table fixed-header height="450px">
            <template v-slot:default>
              <thead>
                <tr class="primary">
                  <th class="primary white--text" width="100%">
                    Avertising & Promotion
                  </th>
                  <th class="primary white--text text-center" colspan="11">
                    Agreed Supporting Documents
                  </th>
                </tr>
                <tr class="primary">
                  <th class="secondblue white--text">
                    Type of Activity
                  </th>
                  <th class="secondblue white--text">
                    A&P Investment Breakdown (Plan)
                  </th>
                  <th class="secondblue white--text">
                    Cost Estimation & Detail Breakdown (Plan)
                  </th>
                  <th class="secondblue white--text">
                    Proposal
                  </th>
                  <th class="secondblue white--text">
                    Media Schedule & Campaign (Plan)
                  </th>
                  <th class="secondblue white--text">
                    Storyboard
                  </th>
                  <th class="secondblue white--text">
                    Agreement (Draft) 80 W
                  </th>
                  <th class="secondblue white--text">
                    ROI
                  </th>
                  <th class="secondblue white--text">
                    Distribution Allocation/ List Participant (Plan)
                  </th>
                  <th class="secondblue white--text">
                    Cost Benchmark
                  </th>
                  <th class="secondblue white--text">
                    List Brand by SKU
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(docs, index) in support_docs" :key="index">
                  <td>{{ docs.type }}</td>
                  <td>
                    <v-icon :color="docs.ap_investment ? 'success' : 'error'">
                      {{
                        docs.ap_investment === true
                          ? 'check_circle'
                          : 'highlight_off'
                      }}
                    </v-icon>
                  </td>
                  <td>
                    <v-icon :color="docs.cost_estimation ? 'success' : 'error'">
                      {{
                        docs.cost_estimation === true
                          ? 'check_circle'
                          : 'highlight_off'
                      }}
                    </v-icon>
                  </td>
                  <td>
                    <v-icon :color="docs.proposal ? 'success' : 'error'">
                      {{
                        docs.proposal === true
                          ? 'check_circle'
                          : 'highlight_off'
                      }}
                    </v-icon>
                  </td>
                  <td>
                    <v-icon :color="docs.media_schedule ? 'success' : 'error'">
                      {{
                        docs.media_schedule === true
                          ? 'check_circle'
                          : 'highlight_off'
                      }}
                    </v-icon>
                  </td>
                  <td>
                    <v-icon :color="docs.storyboard ? 'success' : 'error'">
                      {{
                        docs.storyboard === true
                          ? 'check_circle'
                          : 'highlight_off'
                      }}
                    </v-icon>
                  </td>
                  <td>
                    <v-icon :color="docs.agreement ? 'success' : 'error'">
                      {{
                        docs.agreement === true
                          ? 'check_circle'
                          : 'highlight_off'
                      }}
                    </v-icon>
                  </td>
                  <td>
                    <v-icon :color="docs.roi ? 'success' : 'error'">
                      {{ docs.roi === true ? 'check_circle' : 'highlight_off' }}
                    </v-icon>
                  </td>
                  <td>
                    <v-icon :color="docs.distribution ? 'success' : 'error'">
                      {{
                        docs.distribution === true
                          ? 'check_circle'
                          : 'highlight_off'
                      }}
                    </v-icon>
                  </td>
                  <td>
                    <v-icon :color="docs.cost_benchmark ? 'success' : 'error'">
                      {{
                        docs.cost_benchmark === true
                          ? 'check_circle'
                          : 'highlight_off'
                      }}
                    </v-icon>
                  </td>
                  <td>
                    <v-icon :color="docs.brand ? 'success' : 'error'">
                      {{
                        docs.brand === true ? 'check_circle' : 'highlight_off'
                      }}
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      support_docs: [
        {
          type: 'Media Space',
          ap_investment: true,
          cost_estimation: true,
          proposal: false,
          media_schedule: true,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Media Digital',
          ap_investment: true,
          cost_estimation: true,
          proposal: false,
          media_schedule: true,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Media Agency Fees',
          ap_investment: true,
          cost_estimation: true,
          proposal: false,
          media_schedule: true,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Advert Agency Fees',
          ap_investment: true,
          cost_estimation: true,
          proposal: false,
          media_schedule: false,
          storyboard: false,
          agreement: true,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Content Production',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: true,
          agreement: false,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Brand Ambassador',
          ap_investment: true,
          cost_estimation: true,
          proposal: false,
          media_schedule: false,
          storyboard: false,
          agreement: true,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Activation',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Mama Class',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: true,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Sampling',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: true,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Write Off',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: true
        },
        {
          type: 'PR Sponsoring',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: false,
          cost_benchmark: true,
          brand: false
        },
        {
          type: 'PR Sponsoring Project',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: true,
          roi: false,
          distribution: false,
          cost_benchmark: true,
          brand: false
        },
        {
          type: 'Licensing',
          ap_investment: true,
          cost_estimation: true,
          proposal: false,
          media_schedule: false,
          storyboard: false,
          agreement: true,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Call Centers',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'CRM',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Market Research/Cons Insight',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Design Packaging',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: false,
          roi: false,
          distribution: false,
          cost_benchmark: false,
          brand: false
        },
        {
          type: 'Gimmick & Transportation',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: false,
          roi: true,
          distribution: true,
          cost_benchmark: true,
          brand: false
        },
        {
          type: 'POSM & Transportation',
          ap_investment: true,
          cost_estimation: true,
          proposal: true,
          media_schedule: false,
          storyboard: false,
          agreement: false,
          roi: true,
          distribution: true,
          cost_benchmark: true,
          brand: false
        }
      ]
    };
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  }
};
</script>
